import GUI from 'lil-gui';

export const gui = window.location.hash === '#debug' ? new GUI() : null;

if (gui) {
  gui.close();
}
